import imageCompression from 'browser-image-compression';

export class ImageCompressor {
  /**
   * Compress an image file to be under a max size (in bytes), keeping original resolution as much as possible.
   * @param file The image file to compress
   * @param maxSizeMB Maximum size in MB (default 50MB)
   * @returns Compressed File
   */
  static async compressImage(file: File, maxSizeMB = 50): Promise<File> {
    // browser-image-compression will try to keep resolution if maxWidth/Height not set
    const options = {
      maxSizeMB,
      useWebWorker: true,
      maxWidthOrHeight: undefined, // keep original resolution
      initialQuality: 0.8,
      alwaysKeepResolution: true as any, // not in types, but supported
    };
    try {
      const compressedFile = await imageCompression(file, options);
      return compressedFile;
    } catch (error) {
      throw new Error('No se pudo comprimir la imagen: ' + (error as Error).message);
    }
  }
}
